export default function isStripePayment (resource, paymentProviders) {
  return paymentProviders.some(paymentProvider => {
    return paymentProvider.id_code === 'stripe' &&
           paymentProvider.id === resource.payment_provider_id
  })
}
